(function () {
  'use strict';

  angular
    .module('helpers')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('helpers', {
        url: '/helpers',
        templateUrl: 'helpers/helpers.tpl.html',
        controller: 'HelpersCtrl',
        controllerAs: 'helpers'
      });
  }
}());
